import { Capacitor, registerPlugin } from '@capacitor/core';
import { GoogleAuthProvider, signInWithCredential, signInWithRedirect, getRedirectResult, Auth, User, UserCredential, reauthenticateWithCredential, reauthenticateWithPopup } from 'firebase/auth';
const nativeGoogle = registerPlugin<{signIn(): Promise<{idToken: string; accessToken: string}>}>('FinFlowGoogle');
function webGoogle() {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({prompt: 'select_account'});
  return provider;
}
export async function reauthenticateGoogle(user: User) {
  if (Capacitor.getPlatform() === 'android') {
    const { androidGoogleCredential } = await import('./androidAuth');
    const tokens = await androidGoogleCredential();
    await reauthenticateWithCredential(user, GoogleAuthProvider.credential(tokens.idToken, tokens.accessToken));
  } else if (Capacitor.getPlatform() === 'ios') {
    const tokens=await nativeGoogle.signIn();
    if(!tokens.idToken)throw new Error('Google did not return a sign-in token.');
    await reauthenticateWithCredential(user,GoogleAuthProvider.credential(tokens.idToken,tokens.accessToken));
  } else {
    await reauthenticateWithPopup(user,webGoogle());
  }
  return user.getIdToken(true);
}
export const completeGoogleRedirect=(auth:Auth)=>getRedirectResult(auth);
export async function signInWithGoogle(auth: Auth): Promise<UserCredential|null> {
  if (Capacitor.getPlatform() === 'android') {
    const { androidGoogleCredential } = await import('./androidAuth');
    const tokens = await androidGoogleCredential();
    return signInWithCredential(auth, GoogleAuthProvider.credential(tokens.idToken, tokens.accessToken));
  }
  if (Capacitor.getPlatform() === 'ios') {
    const tokens = await nativeGoogle.signIn();
    if (!tokens.idToken) throw new Error('Google did not return a sign-in token.');
    return signInWithCredential(auth, GoogleAuthProvider.credential(tokens.idToken, tokens.accessToken));
  }
  // Popup sign-in opens /__/auth/handler in a second window. When that window
  // has no opener (mobile, embedded browsers, or a popup that became a tab),
  // Google returns a code and the handler never hands it back to Login.
  await signInWithRedirect(auth, webGoogle());
  return null;
}

// Existing deletion callers retain their provider reauthentication behavior.
export const reauthenticateGoogleForDeletion = reauthenticateGoogle;
